/* NEX cart drawer: 3 separate offer meters, smart picks, discount code, note */
(function () {
'use strict';
var root = document.querySelector('[data-cart]');
if (!root) return;
var cfg = {};
try { cfg = JSON.parse(root.querySelector('[data-cart-config]').textContent) || {}; } catch (e) {}
var $ = function (s, r) { return (r || document).querySelector(s); };
var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
var money = function (c) { return 'EGP ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
var img = function (u, w) { if (!u) return ''; u = typeof u === 'string' ? u : (u.src || u.url || ''); return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; };
var body = $('[data-cart-body]', root), countEl = $('[data-cart-title-count]', root);
var cart = null, capIds = null, pools = {}, prevQ = {}, prevUnlock = {}, code = '';
try { code = localStorage.getItem('nex:code') || ''; } catch (e) {}

function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
function post(u, b) {
return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
}
function setCount(n) { [].forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = n; el.hidden = !n; }); }
function coll(key, handle) {
if (pools[key]) return Promise.resolve(pools[key]);
return getJSON('/collections/' + handle + '/products.json?limit=250').then(function (d) { pools[key] = d.products || []; return pools[key]; }).catch(function () { return []; });
}
function capsReady() {
if (capIds) return Promise.resolve();
return coll('cap', cfg.capHandle || 'vintage-washed-cap').then(function (l) { capIds = {}; l.forEach(function (p) { capIds[p.id] = 1; }); });
}

var TEE = { 't-shirts': 1, 't-shirt': 1, 'basic t-shirts': 1 };
var T = { cap: cfg.capTitle || 'Buy 3 Caps Get 1 Free', tee: cfg.teeTitle || 'Buy 3 Summer Tees, Get a Cap Free', hoodie: cfg.hoodieTitle || 'Buy 3 Hoodies, Get the 4th 50% Off' };
function allocs(it, title) {
var t = (title || '').toLowerCase();
return (it.line_level_discount_allocations || []).filter(function (a) { return a.discount_application && (a.discount_application.title || '').toLowerCase() === t; });
}
function freed(it, title) {
var amt = 0; allocs(it, title).forEach(function (a) { amt += a.amount; });
return it.original_price > 0 ? Math.min(it.quantity, Math.round(amt / it.original_price)) : 0;
}
function applied(title) { return cart.items.some(function (it) { return allocs(it, title).length > 0; }); }
function isCap(it) { return !!(capIds && capIds[it.product_id]); }
function expand(arr) { var u = []; arr.forEach(function (x) { for (var i = 0; i < x.n; i++) u.push(x.it); }); return u; }

/* each offer is counted like its own Shopify discount; caps given free by the tee offer never count toward the cap offer */
var OFFERS = [
{ key: 'tee', noun: 'summer tee', nouns: 'summer tees', title: T.tee, badge: 'FREE HAT', pool: function () { return coll('tee', cfg.teeHandle || 'summer-tees'); }, gift: 'cap',
units: function () { return expand(cart.items.filter(function (it) { return TEE[(it.product_type || '').toLowerCase()]; }).map(function (it) { return { it: it, n: it.quantity }; })); },
giftUnits: function () { return expand(cart.items.filter(isCap).map(function (it) { return { it: it, n: freed(it, T.tee) }; })); } },
{ key: 'cap', noun: 'hat', nouns: 'hats', title: T.cap, badge: 'FREE', reward: 'FREE', pool: function () { return coll('cap', cfg.capHandle || 'vintage-washed-cap'); },
units: function () { return expand(cart.items.filter(isCap).map(function (it) { return { it: it, n: it.quantity - freed(it, T.tee) }; })); } },
{ key: 'hoodie', noun: 'hoodie or crewneck', nouns: 'hoodies or crewnecks', title: T.hoodie, badge: '50% OFF', reward: '50% off', pool: function () { return coll('hoodie', cfg.hoodieHandle || 'hoodies'); },
units: function () { return expand(cart.items.filter(function (it) { return (it.product_type || '').toLowerCase() === 'hoodie'; }).map(function (it) { return { it: it, n: it.quantity }; })); } }
];

function slot(u, k, gift, o, key, was, label) {
var cls = 'om__slot' + (gift ? ' om__slot--gift' : '') + (u ? ' is-full' : '') + (u && k >= was ? ' is-new' : '');
var em = gift ? '<em>' + o.badge + '</em>' : '';
return u ? '<span class="' + cls + '" style="--k:' + k + '" data-unit="' + esc(u.key) + '" role="button" tabindex="0" aria-label="Tap to remove this ' + label + '"><img src="' + esc(img(u.image, 120)) + '" alt="">' + em + '<b class="om__rm" data-unit-rm>Remove</b></span>'
: '<button type="button" class="' + cls + '" data-pick="' + key + '" aria-label="Add a ' + label + '">' + (gift ? em : '+') + '</button>';
}
function meter(o) {
var units = o.units(), q = Math.min(units.length, o.gift ? 3 : 99), unlocked, msg, gu = null;
if (o.gift) {
gu = o.giftUnits()[0];
unlocked = q >= 3 && !!gu && applied(o.title);
if (q === 0) msg = 'Buy 3 summer tees, get a <b>FREE hat</b>';
else if (q < 3) msg = '<b>' + (3 - q) + ' more summer ' + (3 - q === 1 ? 'tee' : 'tees') + '</b> and a hat is <b>FREE</b>';
else if (unlocked) msg = '<b>Unlocked!</b> Your hat is FREE';
else msg = 'Add any hat, it’s <b>FREE</b>';
} else {
unlocked = q >= 4 && applied(o.title);
if (q === 0) msg = 'Buy 3 ' + o.nouns + ', get the 4th <b>' + o.reward + '</b>';
else if (q < 3) msg = '<b>' + (3 - q) + ' more ' + (3 - q === 1 ? o.noun : o.nouns) + '</b> and your 4th is ' + o.reward;
else if (q === 3) msg = 'Add your 4th ' + o.noun + ', it’s <b>' + o.reward + '</b>';
else if (unlocked) msg = '<b>Unlocked!</b> Your 4th ' + o.noun + ' is ' + o.reward;
else msg = 'Your 4th ' + o.noun + ' deal applies at checkout';
}
var was = prevQ[o.key] || 0, burst = unlocked && !prevUnlock[o.key];
prevQ[o.key] = q; prevUnlock[o.key] = unlocked;
var slots = '';
for (var i = 0; i < 3; i++) slots += slot(units[i], i, false, o, o.key, was, o.noun);
slots += o.gift ? slot(gu, 3, true, o, o.gift, was, 'hat') : slot(units[3], 3, true, o, o.key, was, o.noun);
var f = o.gift ? (unlocked ? 1 : Math.min(q, 3) / 3 * .66) : Math.max(0, (Math.min(q, 4) - 1) / 3);
return '<div class="om om--' + o.key + (unlocked ? ' is-unlocked' : '') + (burst ? ' is-burst' : '') + '" style="--f:' + f + '">' +
'<p class="om__msg">' + msg + '</p><div class="om__track"><span class="om__bar"></span>' + slots + '</div>' +
(burst ? '<span class="om__fx" aria-hidden="true">' + new Array(9).join('<i></i>') + '</span>' : '') + '</div>';
}

function lineHTML(it) {
var tags = (it.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0; }).map(function (a) {
return '<span class="cl__tag">' + (it.final_line_price === 0 ? 'FREE' : '−' + money(a.amount)) + '</span>';
}).join('');
var opts = it.product_has_only_default_variant ? '' : '<p class="cl__var">' + esc(it.variant_title) + '</p>';
return '<li class="cl" data-key="' + esc(it.key) + '"><a class="cl__img" href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy"></a>' +
'<div class="cl__info"><a class="cl__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + opts +
'<p class="cl__price">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s> ' : '') + money(it.final_line_price) + tags + '</p>' +
'<div class="cl__row"><div class="cl__qty"><button type="button" data-q="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
'<button type="button" class="cl__rm" data-q="0">Remove</button></div></div></li>';
}

function card(p) { return window.NexOpts ? NexOpts.card(p, { esc: esc, img: img, money: money }) : ''; }
function recsFor(pid) {
if (pools['r' + pid]) return Promise.resolve(pools['r' + pid]);
return getJSON('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
.then(function (d) { pools['r' + pid] = d.products || []; return pools['r' + pid]; }).catch(function () { return []; });
}
function fillRecs(list, title) {
var box = $('[data-cart-recs]', root);
if (!box) return;
var inCart = {};
cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
var html = list.filter(function (p) { return !inCart[p.id]; }).slice(0, 8).map(card).join('');
box.innerHTML = html ? '<p class="cd__h">' + esc(title) + '</p><div class="rc-row">' + html + '</div>' : '';
moreUpd();
}
/* smart picks: related to the last item in the bag (hoodies -> hoodies, caps -> caps) plus best sellers of the same kind */
function smart(it) {
var pt = (it.product_type || '').toLowerCase();
var kind = isCap(it) ? (cfg.capHandle || 'vintage-washed-cap') : (pt === 'hoodie' ? 'hoodies' : (TEE[pt] ? 'summer-tees' : 'all'));
return Promise.all([recsFor(it.product_id), getJSON('/collections/' + kind + '/products.json?sort_by=best-selling&limit=12').then(function (d) { return d.products || []; }).catch(function () { return []; })])
.then(function (r) { var seen = {}; return r[0].concat(r[1]).filter(function (p) { if (seen[p.id]) return false; seen[p.id] = 1; return true; }); });
}

/* "scroll down" cue: soft arrows above the footer while there is more to see, gone once the shopper scrolls */
var panel = $('.cd__panel', root) || root, more = document.createElement('div'), scrolled = false;
more.className = 'cd__more'; more.setAttribute('aria-hidden', 'true'); more.innerHTML = '<span>Scroll</span><i></i><i></i>';
panel.appendChild(more);
function moreUpd() {
var f = $('.cd__foot', body), pr = panel.getBoundingClientRect();
more.style.bottom = ((f ? pr.bottom - f.getBoundingClientRect().top : 0) + 10) + 'px';
var left = body.scrollHeight - body.scrollTop - body.clientHeight;
more.classList.toggle('is-on', !scrolled && left > 70 && root.classList.contains('is-open'));
}
body.addEventListener('scroll', function () { if (body.scrollTop > 24) scrolled = true; moreUpd(); }, { passive: true });
window.addEventListener('resize', moreUpd);

function render() {
countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
var ms = OFFERS.map(function (o) { return { o: o, q: o.units().length }; });
var act = ms.filter(function (x) { return x.q > 0; });
var meters = (act.length ? act : ms).map(function (x) { return meter(x.o); }).join('');
var ann = cfg.announce ? '<p class="cd__ann">' + esc(cfg.announce) + '</p>' : '';
if (!cart.item_count) {
body.innerHTML = ann + '<div class="cd__offers">' + meters + '</div>' +
'<div class="cd__empty"><p>Your bag is empty.</p><a class="cd__btn" href="' + esc(cfg.shopUrl || '/collections/all') + '">Start shopping</a></div><div data-cart-recs></div>';
getJSON('/collections/all/products.json?sort_by=best-selling&limit=12').then(function (d) { fillRecs(d.products || [], 'Best sellers'); }).catch(function () {});
setTimeout(moreUpd, 80);
return;
}
var save = cart.total_discount || 0;
body.innerHTML = ann +
'<div class="cd__offers">' + meters + '</div><ul class="cd__lines">' + cart.items.map(lineHTML).join('') + '</ul><div data-cart-recs></div>' +
'<div class="cd__extra"><div class="cd__code">' + (code
? '<span class="cd__chip">' + esc(code) + ' <small>applied at checkout</small><button type="button" data-code-rm aria-label="Remove code">×</button></span>'
: '<input type="text" placeholder="Discount code" aria-label="Discount code" data-code-in><button type="button" data-code-add>Apply</button>') + '</div>' +
(cfg.note ? '<details class="cd__note"><summary>Add order note</summary><textarea rows="2" data-note>' + esc(cart.note || '') + '</textarea></details>' : '') + '</div>' +
'<div class="cd__foot">' + (save ? '<p class="cd__save"><span>You save</span><b>' + money(save) + '</b></p>' : '') +
'<p class="cd__sub"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></p>' +
(cfg.delivery ? '<p class="cd__del">' + esc(cfg.delivery) + '</p>' : '') +
(cfg.terms ? '<label class="cd__terms"><input type="checkbox" data-terms> ' + esc(cfg.terms) + '</label>' : '') +
'<a class="cd__btn cd__btn--go" href="/checkout" data-go>' + (window.NexOpts ? NexOpts.LOCK : '') + '<span>Checkout • ' + money(cart.total_price) + '</span></a>' + (window.NexOpts ? NexOpts.PAY : '') + '</div>';
smart(cart.items[cart.items.length - 1]).then(function (l) { fillRecs(l, 'Complete the look'); });
setTimeout(moreUpd, 80);
}

function refresh() { return capsReady().then(function () { return getJSON('/cart.js'); }).then(function (c) { cart = c; setCount(c.item_count); render(); return c; }); }
function open() {
root.hidden = false;
scrolled = false;
requestAnimationFrame(function () { root.classList.add('is-open'); });
document.body.style.overflow = 'hidden';
root.setAttribute('aria-hidden', 'false');
var c = $('[data-cart-close]', root); if (c) c.focus({ preventScroll: true });
setTimeout(moreUpd, 700);
}
function close() {
root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
more.classList.remove('is-on');
setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 450);
}
function addVariant(id, btn) {
if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
return post('/cart/add.js', { items: [{ id: +id, quantity: 1 }] }).then(refresh)
.catch(function (e) { flash((e && e.description) || 'Could not add this item'); })
.then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
}
function flash(t) {
var f = $('[data-cart-flash]', root); if (!f) return;
f.textContent = t; f.classList.add('is-on'); clearTimeout(flash.t); flash.t = setTimeout(function () { f.classList.remove('is-on'); }, 2600);
}

/* tap a picked item inside an offer box: it shows "Remove"; tap again to take that one out and pick another */
function unitTap(sl, rm) {
if (!rm) {
var was = sl.classList.contains('is-sel');
[].forEach.call(root.querySelectorAll('.om__slot.is-sel'), function (x) { x.classList.remove('is-sel'); });
if (!was) sl.classList.add('is-sel');
return;
}
var key = sl.getAttribute('data-unit'), it = cart.items.filter(function (x) { return x.key === key; })[0];
if (!it) return;
sl.classList.add('is-busy');
post('/cart/change.js', { id: it.key, quantity: Math.max(0, it.quantity - 1) }).then(function (c) { cart = c; setCount(c.item_count); render(); })
.catch(function (er) { sl.classList.remove('is-busy'); flash((er && er.description) || 'Could not update'); });
}

root.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest('.om__slot.is-sel')) [].forEach.call(root.querySelectorAll('.om__slot.is-sel'), function (x) { x.classList.remove('is-sel'); });
var us = t.closest('[data-unit]');
if (us) return unitTap(us, !!t.closest('[data-unit-rm]') && us.classList.contains('is-sel'));
if (t.closest('[data-cart-close]')) return close();
var q = t.closest('[data-q]');
if (q) {
var li = q.closest('[data-key]'), it = cart.items.filter(function (x) { return x.key === li.getAttribute('data-key'); })[0];
var n = +q.getAttribute('data-q') === 0 ? 0 : Math.max(0, it.quantity + +q.getAttribute('data-q'));
li.classList.add('is-busy');
return post('/cart/change.js', { id: it.key, quantity: n }).then(function (c) { cart = c; setCount(c.item_count); render(); })
.catch(function (er) { li.classList.remove('is-busy'); flash((er && er.description) || 'Could not update'); });
}
if (window.NexOpts && NexOpts.click(t, addVariant)) return;
var a = t.closest('[data-add-id]');
if (a) return addVariant(a.getAttribute('data-add-id'), a);
var pk = t.closest('[data-pick]');
if (pk) {
var o = OFFERS.filter(function (x) { return x.key === pk.getAttribute('data-pick'); })[0];
pk.classList.add('is-busy');
return o.pool().then(function (list) { fillRecs(list, 'Add a ' + o.noun); var b = $('[data-cart-recs]', root); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); pk.classList.remove('is-busy'); });
}
if (t.closest('[data-code-add]')) {
var inp = $('[data-code-in]', root), v = (inp.value || '').trim().toUpperCase();
if (!v) return inp.focus();
code = v; try { localStorage.setItem('nex:code', code); } catch (er) {} return render();
}
if (t.closest('[data-code-rm]')) { code = ''; try { localStorage.removeItem('nex:code'); } catch (er) {} return render(); }
var go = t.closest('[data-go]');
if (go) {
var terms = $('[data-terms]', root);
if (terms && !terms.checked) { e.preventDefault(); terms.parentNode.classList.add('is-shake'); setTimeout(function () { terms.parentNode.classList.remove('is-shake'); }, 500); return; }
if (code) { e.preventDefault(); location.href = '/checkout?discount=' + encodeURIComponent(code); }
}
});
root.addEventListener('keydown', function (e) {
if (e.key === 'Enter' && e.target.matches('[data-code-in]')) { e.preventDefault(); $('[data-code-add]', root).click(); }
if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-unit]')) { e.preventDefault(); unitTap(e.target, e.target.classList.contains('is-sel')); }
});
var nt;
root.addEventListener('input', function (e) {
if (!e.target.matches('[data-note]')) return;
clearTimeout(nt); var v = e.target.value; nt = setTimeout(function () { post('/cart/update.js', { note: v }); }, 600);
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

document.addEventListener('click', function (e) {
var a = e.target.closest('a[href]');
if (!a || root.contains(a)) return;
var h = a.getAttribute('href');
if ((h === '/cart' || h === cfg.cartUrl) && location.pathname.indexOf('/cart') !== 0) {
e.preventDefault();
var m = document.querySelector('[data-drawer].is-open [data-menu-close]'); if (m) m.click();
refresh().then(open);
}
});
document.addEventListener('nex:added', function () { refresh().then(open); });

window.NexCart = { open: function () { refresh().then(open); }, refresh: refresh };
})();
